import Card from '../card/Card';
import Label from '../texts/label/Label';

interface IBreadcrumbProps {
  prevRoute?: string;
  currentRoute?: string;
}

const Breadcrumb = ({ prevRoute, currentRoute }: IBreadcrumbProps) => {
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const firstSegment = `${pathSegments[0]}`;

  return (
    <Card display='flex' margin={{ left: '2' }} gap='10px'>
      <Label type='2' variant='neutral'>
        {prevRoute ? prevRoute : 'Inicio'} {'>'}
      </Label>
      <Label type='1' variant='primary' weight='bold'>
        {currentRoute ? currentRoute : firstSegment}
      </Label>
    </Card>
  );
};

export default Breadcrumb;
